/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AgentBadge_agent$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventTimedOut_event$ref: FragmentReference;
export type JobEventTimedOut_event = {|
  +timestamp: any,
  +actor: {|
    +node: ?{|
      +name?: string,
      +uuid?: string,
      +organization?: ?{|
        +slug: string
      |},
      +$fragmentRefs: AgentBadge_agent$ref,
    |}
  |},
  +exitStatus?: number,
  +$refType: JobEventTimedOut_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventTimedOut_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent",
              "args": null
            },
            {
              "kind": "InlineFragment",
              "type": "Agent",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "uuid",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "organization",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Organization",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "slug",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "type": "JobEventTimedOut",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "exitStatus",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f1117be8b29d331e850770f1582491ee';
module.exports = node;
